import axiosInstance from '../plugin/axios';

interface FetchContractsParams {
  startDate: string;
  endDate: string;
  name?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface ContractsResponse {
  obtainId: number;
  orderId: number;
  target: string;
  name: string;
  work: string;
}

interface ContractDetailResponse {
  obtainId: number;
  orderId: number;
  name: string;
  wanted: string;
  targetDate: string;
  targetTime: string;
  work: string;
  createdAt: string;
  obtainStatus: string;
}

export const fetchDriverContract = async (
  params: FetchContractsParams,
): Promise<ContractsResponse[]> => {
  console.log('params:', params);
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      name,
      limit = 1000,
      sortBy = 'target',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<ContractsResponse[]>(
      '/api/obtain/list',
      {
        params: {
          startDate,
          endDate,
          name,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('수주 내역 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('수주 내역 데이터를 불러오는 데 실패했습니다.');
  }
};

export const getContractDetail = async (
  obtainId: number,
): Promise<ContractDetailResponse> => {
  try {
    const response = await axiosInstance.get<ContractDetailResponse>(
      `/api/obtain/${obtainId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error('수주 내역 상세 조회에 실패 했습니다.');
  }
};

export const delelteObtainContract = async (obtainId: number) => {
  try {
    const response = await axiosInstance.delete(`/api/obtain/${obtainId}`);

    return response.data;
  } catch (error) {
    throw new Error('수주 내역 삭제에 실패했습니다.');
  }
};
